const Icon = ({ symbol, label, decorative = false, className }) => {
    const classes = ['landing-icon'];
    if (className) {
        classes.push(className);
    }

    if (decorative || !label) {
        return (
            <span className={classes.join(' ')} aria-hidden="true">
                {symbol}
            </span>
        );
    }

    return (
        <span className={classes.join(' ')} role="img" aria-label={label}>
            {symbol}
        </span>
    );
};

export default Icon;
